import React, { useCallback, useState, createContext, useContext } from 'react';
import { Toast } from '../components/ui/Toast';
type ToastType = 'success' | 'error' | 'info';
interface ToastContextType {
  showToast: (message: string, type: ToastType) => void;
}
const ToastContext = createContext<ToastContextType | undefined>(undefined);
export function ToastProvider({
  children
}: {
  children: React.ReactNode;
}) {
  const [toast, setToast] = useState<{
    message: string;
    type: ToastType;
  } | null>(null);
  const showToast = useCallback((message: string, type: ToastType) => {
    setToast({
      message,
      type
    });
  }, []);
  const hideToast = useCallback(() => {
    setToast(null);
  }, []);
  return <ToastContext.Provider value={{
    showToast
  }} data-id="element-2186">
      {children}
      {toast && <Toast message={toast.message} type={toast.type} onClose={hideToast} data-id="element-2187" />}
    </ToastContext.Provider>;
}
export function useToast() {
  const context = useContext(ToastContext);
  if (!context) {
    throw new Error('useToast must be used within ToastProvider');
  }
  return context;
}